export default __webpack_public_path__ + "static/angularjs-development-company-peerbits-2f84a609c2dc87106c2244851bf0caba.png";